class SimOption {
  constructor({ rootRouter, container, cache, advice = [], excludeProxys, proxy, using } = {}) {
    this.rootRouter = rootRouter;
    this.container = container;
    this.advice = advice;
    this.excludeProxys = excludeProxys;
    this.proxy = proxy;
    this.using = using;
    this.cache = cache;
  }
  addAdvicce(advice) {
    this.advice ??= [];
    this.advice.push(advice);
  }
  setAdvice(...advice) {
    this.advice = advice;
    return this;
  }
}
export {
  SimOption
};
//# sourceMappingURL=SimOption.js.map
